import apiClient from './client'
import { apiEndpoints } from '@/config/api'

/**
 * Gallery API
 * Handles gallery image operations
 */

export const galleryApi = {
  /**
   * Get all gallery images
   * @param {string} collection - Optional collection filter
   * @returns {Promise} Gallery images array
   */
  async getGallery(collection = null) {
    const endpoint = collection 
      ? apiEndpoints.gallery.byCollection(collection)
      : apiEndpoints.gallery.list
    
    const response = await apiClient.get(endpoint, {
      params: collection ? {} : { collection }
    })
    return response.data
  },

  /**
   * Get gallery images by collection
   * @param {string} collection - Collection name (e.g., 'hero-gallery')
   * @returns {Promise} Gallery images array
   */
  async getGalleryByCollection(collection) {
    const response = await apiClient.get(apiEndpoints.gallery.byCollection(collection))
    return response.data
  },

  /**
   * Get hero gallery images specifically
   * @returns {Promise} Hero gallery images array
   */
  async getHeroGallery() {
    return this.getGalleryByCollection('hero-gallery')
  },
}

export default galleryApi
